export default __webpack_public_path__ + "static/media/turkgot-screenshot-01.4a9f1dd2.png";